import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getApiBaseUrl } from '../../config/apiBase';

export const useFetchIndustries = () => {
    const [industries, setIndustries] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = getApiBaseUrl();

    useEffect(() => {
        const fetchIndustries = async () => {
            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/industries`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setIndustries(data);
                } else {
                    console.error('Failed to fetch industries:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching industries:', error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchIndustries();
    }, [getAccessTokenSilently]);

    return { industries, loading };
};
